import { SET_CURRENT_FORMTEMPLATE } from 'redux/types'

const setCurrentFormTemplate = (payload) => {
  return { type: SET_CURRENT_FORMTEMPLATE, payload }
}

export {
    setCurrentFormTemplate
}